import { render, staticRenderFns } from "./imagefilePreview.vue?vue&type=template&id=1868bee9"
import script from "./imagefilePreview.vue?vue&type=script&lang=js"
export * from "./imagefilePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports